import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SurveyCreationAudienceEffects } from './state/audience/survey-creation-audience.effects';
import { SurveyCreationRecalculatePricingEffects } from './state/audience/survey-creation-recalculate-pricing.effects';
import { SurveyCreationReferenceEffects } from './state/reference/survey-creation-reference.effects';
import { surveyCreationFeature } from './state/survey-creation.feature';

export const SURVEY_CREATION_STORE_PROVIDERS = {
  feature: provideState(surveyCreationFeature),
  effects: provideEffects(
    SurveyCreationAudienceEffects,
    SurveyCreationRecalculatePricingEffects,
    SurveyCreationReferenceEffects,
  ),
};
